import { render, staticRenderFns } from "./LongTextQuestion.vue?vue&type=template&id=0d2d25cc&scoped=true&"
import script from "./LongTextQuestion.vue?vue&type=script&lang=ts&"
export * from "./LongTextQuestion.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d2d25cc",
  null
  
)

export default component.exports